import { Link } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/lib/auth";
import { cn } from "@/lib/utils";
import { BrandHeader } from "@/components/layouts/BrandHeader";
import type { ReactNode } from "react";

/**
 * Public chrome — used on the persona-specific landing page and /login.
 * The persona's brand drives the header title + theme. After auth the user
 * crosses into `/app/*` which renders inside its persona shell instead.
 */
export function AppShell({ children, className }: { children: ReactNode; className?: string }) {
  const { user, logout } = useAuth();

  return (
    <div className="flex min-h-screen flex-col">
      <BrandHeader>
        <nav className="flex items-center gap-2">
          {user ? (
            <>
              <Button asChild variant="ghost" size="sm" className="text-cream">
                <Link to="/app">{user.name ?? user.email}</Link>
              </Button>
              <Button onClick={() => void logout()} variant="outline" size="sm">
                Sign out
              </Button>
            </>
          ) : (
            <Button asChild variant="outline" size="sm">
              <Link to="/login">Sign in</Link>
            </Button>
          )}
        </nav>
      </BrandHeader>

      <main className={cn("flex-1", className)}>{children}</main>

      <footer className="border-t bg-canvas/60 py-6 text-center text-xs text-muted-foreground">
        <div className="container space-y-1">
          <p>Taste of Tulum · Food &amp; Wine Festival · Oct 28 – Nov 27, 2026</p>
          <p>All prices in US dollars.</p>
        </div>
      </footer>
    </div>
  );
}
